import { tasksFixtures } from "./fixtures/tasks";

export type TaskStatus = "Da fare" | "In corso" | "Completato";
export type TaskPriority = "Urgente" | "Alta" | "Normale";
export type Task = {
  id: string;
  titolo: string;
  descrizione: string;
  responsabile: string;
  stato: TaskStatus;
  priorita: TaskPriority;
  scadenza: string;
  azienda: string;
  processo: string;
  origine: string;
};

const tasks = tasksFixtures.map((task) => ({ ...task }));
const delay = (ms: number) => new Promise<void>((resolve) => window.setTimeout(resolve, ms));

export async function listTasks(): Promise<Task[]> {
  await delay(240);
  return tasks.map((task) => ({ ...task }));
}

export async function getTask(id: string): Promise<Task | undefined> {
  await delay(180);
  const task = tasks.find((item) => item.id === id);
  return task ? { ...task } : undefined;
}

export async function updateTaskStatus(id: string, stato: TaskStatus): Promise<Task | undefined> {
  await delay(220);
  const task = tasks.find((item) => item.id === id);
  if (!task) return undefined;
  task.stato = stato;
  return { ...task };
}
